import { Injectable, OnDestroy, OnInit } from '@angular/core';
// import {Network, NetworkOriginal} from '@ionic-native/network';
import { Platform, ToastController } from '@ionic/angular';
import { map } from 'rxjs/operators';
import { Network } from '@capacitor/network';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { BehaviorSubject, Observable } from 'rxjs';

/*
 Generated class for the ConnectionService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class ConnectionService implements OnInit, OnDestroy {
    private connected: boolean;
    private connectionType;
    private networktype: string;
    // networkStatus: boolean;

    private networkStatus = new BehaviorSubject<boolean>(true);
    constructor(private platform: Platform,
      private toastCtl: ToastController) {
        //   const net= new NetworkOriginal();
        //   this.networktype=net.type;
        //         net.onConnect().subscribe(() => {
        //             this.onConnect();
        //         });
        //         net.onDisconnect().subscribe(() => {
        //             this.onDisconnect();
        //         });
      this.initializeNetworkMonitoring();

      // Check network status periodically as a fallback
      setInterval(() => {
        Network.getStatus().then(status => {
          if (this.networkStatus.value !== status.connected) {
            this.networkStatus.next(status.connected);
          }
        });
      }, 5000); // Check every 5 seconds
    }
    private async initializeNetworkMonitoring() {
      // Wait for the platform to be ready
      await this.platform.ready();

      // Get initial network status
      const status = await Network.getStatus();
      this.networkStatus.next(status.connected);

      // Start listening for changes
      Network.addListener('networkStatusChange', (status) => {
        console.debug("service - network status change", status)
        this.networkStatus.next(status.connected);
      });
    }

    // Public method to get current status
    public getCurrentNetworkStatus(): boolean {
      return this.networkStatus.value;
    }

    // Observable to subscribe to status changes
    public onNetworkStatusChange(): Observable<boolean> {
      return this.networkStatus.asObservable();
    }
    async ngOnInit() {
      // // Get the current network status
      // const status = await Network.getStatus();
      // this.networkStatus = status.connected;

      // // Listen for network changes
      // Network.addListener('networkStatusChange', status => {

      //   this.networkStatus = status.connected;
      //   console.log('Network status changed:', status.connected, Network.getStatus());
      //   MessageDisplayUtil.showErrorToast(`network changed : ${status?.connected} - ${status?.connectionType}`,
      //   this.platform, this.toastCtl, 5000, 'top')
      // });
    }
    ngOnDestroy() {
      // Remove listeners when component is destroyed
      Network.removeAllListeners();
    }

    private onConnect() {
        this.connected = true;
        setTimeout(() => {
            this.connectionType = this.networktype;
        });
    }

    private onDisconnect() {
        this.connected = false;
        this.connectionType = null;
    }

    /**
     * Checks whether connected to network or not
     * @returns {boolean} Returns true if connected to network
     */
    public isConnected(): boolean {
      return this.networkStatus.value;
        // if (this.platform.is('capacitor'))
        //     return this.networktype !== 'none';
        // else return true;
    }

    /**
     * Checks whether you are connected to WiFi network
     * @returns {boolean} True if connected to WiFi network
     */
    public isWifi(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "wifi";
        else return false;
    }

    /**
     * Checks whether your are connected to 4G network
     * @returns {boolean}
     */
    public is4G(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "4g";
        else return false;
    }

    /**
     * Checks whether connected to 3G network
     * @returns {boolean}
     */
    public is3G(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "3g";
        else return false;
    }

    /**
     * Checks whether connected to 2G network
     * @returns {boolean}
     */
    public is2G(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "2g";
        else return false;
    }
}
